module.exports = __webpack_public_path__ + "img/16.78f20869.jpg";